import React from 'react';

import CreateTemplate from '../../Components/Create';
import Erros from './Erros';
import Form from './Form';
import validate from './Validation';

const Create = (props) => (
  <CreateTemplate
    {...props}
    title="Nova Conta"
    validate={validate}
    onFailure={Erros}
    isBack
  >
    <Form />
  </CreateTemplate>
);

export default Create;
